import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card, Spinner } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { AuthService } from '../../Services/Axios/Api';
import { getRawQueryParam } from '../../utils/queryParams';
const ConfirmEmail = () => {
    const [loading, setLoading] = useState(false);
    const { search } = useLocation();
    const navigate = useNavigate();

    // The token is base64 and contains "+", which URLSearchParams would turn into
    // a space, so it has to be read straight from the raw query string.
    const token = getRawQueryParam(search, 'token');
    const userId = getRawQueryParam(search, 'userId');

    useEffect(() => {
        if (!token || !userId) {
            setTimeout(() => {
                toast.error('Invalid verification link');
            }, 2000);
            navigate('/login');
        }
    }, [token, userId, navigate]);

    const handleVerifyEmail = async () => {
        try {
            setLoading(true);
            const response = await AuthService.verifyEmail({ token, userId });
            console.log(response);
            if (response.isSuccess) {

                toast.success(response.result);
                setTimeout(() => {
                    navigate('/membership');
                }, 2000);
                
            } else {
                toast.error(response.message || 'Failed to verify email');
            }
        } catch (error) {
            toast.error(error.message || 'An error occurred during verification');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="mt-5 mb-5">
            <ToastContainer />
            <Row className="justify-content-center">
                <Col md={6}>
                    <Card className="shadow">
                        <Card.Body className="text-center p-5">
                            <h2 className="mb-4">Verify Your Email</h2>
                            <p className="mb-4">
                                Please click the button below to verify your email address.
                            </p>
                            <Button
                                variant="primary"
                                size="lg"
                                onClick={handleVerifyEmail}
                                disabled={loading || !token || !userId}
                            >
                                {loading ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        Verifying...
                                    </>
                                ) : (
                                    'Verify Email'
                                )}
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ConfirmEmail; 